import Vue from "vue";
import store from "../store/index";
import Router from "vue-router";
// import HelloWorld from "@/components/HelloWorld";

Vue.use(Router);

var npush = Router.prototype.push;
Router.prototype.push = function (loction) {
  return npush.call(this, loction).catch((err) => err);
};

const router = new Router({
  routes: [
    {
      path: "/404",
      component: () => import("@/views/404"),
      hidden: true,
    },
    {
      path: "/",
      component: () => import("@/views/index"),
    },
    {
      path: "/Intelligent",
      component: () => import("@/views/Intelligent"),
    },
    {
      path: "/focusTopic",
      component: () => import("@/views/application/focusTopic"),
    },
    {
      path: "/focusTopicMes",
      component: () => import("@/views/application/focusTopicMes"),
    },
    {
      path: "/focusProductMes",
      component: () => import("@/views/application/focusProductMes"),
    },
    {
      path: "/video",
      component: () => import("@/views/application/video"),
    },
    {
      path: "/question",
      component: () => import("@/views/application/question"),
    },
    {
      path: "/products",
      component: () => import("@/views/products/products"),
    },
    {
      path: "/products2",
      component: () => import("@/views/products/products2"),
    },
    {
      path: "/productsmes",
      component: () => import("@/views/products/productsmes"),
    },
    {
      path: "/download",
      component: () => import("@/views/support/download"),
    },
    {
      path: "/sample",
      component: () => import("@/views/support/sample"),
    },
    {
      path: "/recruitment",
      component: () => import("@/views/support/recruitment"),
    },
    {
      path: "/socialRecruitment",
      component: () => import("@/views/support/socialRecruitment"),
    },
    {
      path: "/profile",
      component: () => import("@/views/company/profile"),
    },
    {
      path: "/honor",
      component: () => import("@/views/company/honor"),
    },
    {
      path: "/history",
      component: () => import("@/views/company/history"),
    },
    {
      path: "/culture",
      component: () => import("@/views/company/culture"),
    },
    {
      path: "/news",
      component: () => import("@/views/company/news"),
    },
    {
      path: "/newsmes",
      component: () => import("@/views/company/newsmes"),
    },
    {
      path: "/joinUs",
      component: () => import("@/views/company/joinUs"),
    },
    {
      path: "/contact",
      component: () => import("@/views/company/contact"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log("tototo", to);
  // if (!localStorage.getItem("lang")) {
  //   localStorage.setItem("lang", 2);
  // }
  store.commit("SET_LANG", localStorage.getItem("lang") || 2);
  //每次进入滚动到页面顶部
  if (!to.query.navindex) {
    window.scrollTo({
      top: 0,
    });
  }
  if (to.path !== from.path) {
    // 路由切换，但不刷新页面
    next();
  } else {
    // 正常导航
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js